@if (forms) {
  <div class="astral-file-upload astral-stack-s">
    @for (form of $any(forms.controls); track form) {
      <div class="astral-file-upload__item astral-section-surface astral-section-surface--compact astral-section-surface--subtle">
        <span class="astral-file-upload__caption">{{ form.controls['caption'].value }}</span>
        <astral-button variant="secondary" size="small" type="button" icon="trash" labelKey="DELETE_BTN" (click)="delete(form)"></astral-button>
      </div>
    }
    @if (showAddButton && fileCount < maxFiles) {
      <astral-button
        [variant]="buttonVariant"
        [size]="buttonSize"
        type="button"
        [icon]="icon"
        [labelKey]="text"
        (click)="uploadFile.click()"
      ></astral-button>
    }
    <input
      #uploadFile
      type="file"
      class="inputfile"
      [attr.accept]="allowedMimeTypes?.join(',') || null"
      (change)="onFileChange($event.target.files)"
    />
  </div>
}
